import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Button, Form, Modal,
} from 'react-bootstrap';
import AlertMessage from '../messages/AlertMessage';

class LoginModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      rememberMe: false,
      validated: false,
      error: props.error,
    };
    this.handleChangeField = this.handleChangeField.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose(event) {
    const { onHide } = this.props;
    onHide(event);
  }

  handleChangeField(event) {
    switch (event.target.id) {
      case 'email': return (this.setState({ email: event.target.value }));
      case 'rememberMe': return (this.setState({ rememberMe: event.target.value === 'on' }));
      case 'password': return (this.setState({ password: event.target.value }));
      default: return this.state;
    }
  }

  handleLogin(event) {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (form.checkValidity() === true) {
      const { onLogin } = this.props;
      const { email, password, rememberMe } = this.state;
      onLogin(email, password, rememberMe).catch((error) => {
        this.setState({ error: error.message });
      });
    }

    this.setState({ validated: true });
  }

  renderLoginForm = () => {
    const { validated, email, password } = this.state;
    return (
      <Form noValidate validated={validated} onSubmit={this.handleLogin} id="loginForm">
        <Form.Group controlId="email">
          <Form.Label>Email address</Form.Label>
          <Form.Control required type="email" placeholder="Enter email" onChange={(event) => this.handleChangeField(event)} value={email} />
          <Form.Control.Feedback type="invalid">
            Please provide your email address.
          </Form.Control.Feedback>
          <Form.Text className="text-muted">
            We&apos;ll never share your email with anyone else.
          </Form.Text>
        </Form.Group>
        <Form.Group controlId="password">
          <Form.Label>Password</Form.Label>
          <Form.Control required type="password" placeholder="Password" onChange={(event) => this.handleChangeField(event)} value={password} />
          <Form.Control.Feedback type="invalid">
            Please provide your password.
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group controlId="rememberMe">
          <Form.Check type="checkbox" label="Remember me" onChange={(event) => this.handleChangeField(event)} />
        </Form.Group>
      </Form>
    );
  }

  render() {
    const { show } = this.props;
    const { error } = this.state;

    return (
      <Modal show={show} onHide={this.handleClose} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            Login
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AlertMessage title={error} />
          {this.renderLoginForm()}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="dark" type="submit" form="loginForm">
            Login
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

LoginModal.propTypes = {
  onLogin: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool,
  error: PropTypes.string,
};

LoginModal.defaultProps = {
  show: true,
  error: undefined,
};

export default LoginModal;
